import React, { useContext, useEffect, useState } from "react";
import Application from "../../../StateContext/Application.js";
import {
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  Excel32,
  JPG32,
  PNG32,
  PDF32,
  Approved32,
  SendBack32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import LimitAllocation from "./LimitAllocation.js";

const LimitAllocationInwardList = () => {
  const operation = useContext(Application);
  const {
    GetReleaseFromFinanceList,
    ReleaseFromFinanceApproval,
    Usermenu,
    GetBudgetHeadInfo,
  } = operation;
 
  const [releaseFromFinance, setReleaseFromFinance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [menuData, setMenuData] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState({
    FinancialYear: "",
    ProjectName: "",
    ReleaseID: "",
    ReleaseAmountTillDate: "",
    BudgetHeadID: null,
    BudgetHeadName: "",
    Agency_Name: "",
    Agency: "",
    ReleaseAmount: 0,
    ReleaseDate: null,
  });
  useEffect(() => {
    ReleaseFromFinanceList();
  }, []);


  const ReleaseFromFinanceList = async () => {
  try {
    const res = await GetReleaseFromFinanceList();
 
    console.log("API Response:", res);
    console.log("Result:", res?.result);
 
    const data = res?.result || [];
 
    // Latest added record first
    const latestFirst = [...data].reverse();
 
    setFilteredBills(latestFirst);
    setReleaseFromFinance(latestFirst);
    setCurrentPage(1);
 
  } catch (error) {
    console.error("Error fetching Release From Finance List:", error);
    setFilteredBills([]);
    setReleaseFromFinance([]);
  }
};
  const handleCheckboxChange = (uniqueID) => {
    setSelectedBills((prevSelected) => {
      if (prevSelected.includes(uniqueID)) {
        return prevSelected.filter((id) => id !== uniqueID);
      }

      return [...prevSelected, uniqueID];
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const currentPageIds = currentBills.map((bill) => bill.UniqueID);

      setSelectedBills((prevSelected) => [
        ...new Set([...prevSelected, ...currentPageIds]),
      ]);
    } else {
      const currentPageIds = currentBills.map((bill) => bill.UniqueID);

      setSelectedBills((prevSelected) =>
        prevSelected.filter((id) => !currentPageIds.includes(id)),
      );
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Budget Estimation selected for approval!");
      return;
    }
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");

    if (shouldStart) {
      try {
        let response = await ReleaseFromFinanceApproval(
          selectedBills,
          condition,
          remark,
        );
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Fund:", error);
        alert("An error occurred while approving Fund.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`AddFund ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Fund Selected !!!");
    }
  };
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);

  // 23-10
 const isChecker =
  (menuData?.Department_Name === "Agency Checker" && menuData?.Role === "Agency Checker") ||
  (menuData?.Department_Name === "State Checker" && menuData?.Role === "State Checker");

  const isMaker =
    menuData?.Department_Name === "Agency Maker" &&
    menuData?.Role === "Agency Maker";

  console.log("menuData", menuData);

  const handleEditProject = async () => {
    if (selectedBills.length !== 1) {
      alert("Please select one record.");
      return;
    }
    try {
      const selectedBill = filteredBills.find(
        (item) => item.UniqueID === selectedBills[0],
      );
      setEditData(selectedBill);
      setOpenEdit(true);
      setShowEditForm(true); // Hide table and show form
    } catch (err) {
      console.log(err);
    }
  };

  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last 3 pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };


  // 08-10
  useEffect(() => {
  const search = searchTerm.trim().toLowerCase();
 
  const filtered = releaseFromFinance.filter((item) =>
    Object.values(item).some((value) =>
      String(value ?? "").toLowerCase().includes(search)
    )
  );
 
  setFilteredBills(filtered);
  setCurrentPage(1);
}, [searchTerm, releaseFromFinance]);
  return (
    <>
      {!openEdit ? (
        <>
          <div
              className="col-12"
            style={{
              backgroundColor: "White",
              height: "90vh",
              overflowX: "hidden",
              //28/10
              overflowY: "auto",
              //29/10
              padding: "15px 20px",       
            boxSizing: "border-box",    

            }}
          >
            <div style={{
    background: "#EEF2F7",
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    padding: "15px 20px 20px",
    width: "100%",
    boxSizing: "border-box",
  }}>
              <div //29/10
              style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "15px",
  }}
            >
                <h5 className="my-auto fw-bold">
                  {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                  {/* 07-10 */}
                   <img
    src="/Limit-Allocation-Inward-List-32.png"
    alt="Limit Inward List"
    style={{
      width: "26px",
      height: "26px",
      marginRight: "8px",
      objectFit: "contain",
    }}
  />
                  <span className="my-auto">Limit Inward List</span>
                </h5>

                <div
                  style={{
                    position: "relative",
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src="/Search32.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                      opacity: 0.6,
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search Here"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    style={{
                      width: "100%",
                      padding: "8px 12px 8px 32px", // left padding makes space for icon
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      fontSize: "14px",
                      color: "#333",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      outline: "none",
                    }}
                  />
                </div>
              </div>

              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "#fff",
                  padding: "24px 20px 18px",
                  boxShadow: "0 3px 12px rgba(0,0,0,0.12)",
                  borderRadius: "16px",
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  overflow: "hidden",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    boxSizing: "border-box",
                    background: "#fff",
                    border: "1px solid #d9e2f2",
                    borderRadius: "8px",
                  }}
                >
                  {SelectedOptions === "Pending" && (
                    <table
                      className="m-0 p-0"
                      style={{
    width: "100%",
    minWidth: "850px",
    borderCollapse: "separate",   
    borderSpacing: 0,             
    tableLayout: "auto",
  }}
                    >
                      <thead>
                        <tr
                            style={{
                            color: "white",
                            backgroundColor: "#2D79D9",
                            border: "none",
                            height: "3rem",
                            fontSize: "14px",
                            fontWeight:"400"
                          }}
                        >
                          <th style={{ minWidth: "50px", padding: "8px" }}>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                currentBills.length > 0 &&
                                currentBills.every((item) =>
                                  selectedBills.includes(item.UniqueID),
                                )
                              }
                              className="my-auto"
                              style={{ height: "1rem", width: "1rem" }}
                            />
                          </th>
                          <th style={{ padding: 10 }}>Sr.No</th>

                         
                          
                          <th style={{ padding: "10px" }}>Release ID</th>
                          <th style={{ padding: "10px" }}>Financial Year</th>
                          <th style={{ padding: "10px" }}>Project Name</th>
                          <th style={{ padding: "10px" }}>Release Amount</th>
                          {/* <th style={{ padding: "10px" }}>Budget Head</th> */}
                          <th style={{ padding: "10px" }}>ReleaseDate</th>
                          {isMaker && (
                            <th style={{ padding: "10px" }}>Remark</th>
                          )}
                           {isMaker && (
                            <th style={{ padding: "10px" }}>Action</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((releasefromfdutf, index) => {
                            const bgColor =
                               index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}
                                key={releasefromfdutf.UniqueID}
                              >
                                
                               

                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{ height: "1rem", width: "1rem" }}
                                    checked={selectedBills.includes(
                                      releasefromfdutf.UniqueID,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        releasefromfdutf.UniqueID,
                                      )
                                    }
                                  />
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {indexOfFirstBill + index + 1}
                                </td>
                                <td style={{ padding: "10px", color: "rgb(82, 149, 201)",textAlign:"center" }}>
                                  {releasefromfdutf.ReleaseID}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {releasefromfdutf.FinancialYear}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {releasefromfdutf.ProjectName}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  ₹
                                  {Number(
                                    releasefromfdutf.ReleaseAmount || 0,
                                  ).toLocaleString("en-IN")}
                                </td>
                                {/* <td style={{ padding: "10px" }}>{releasefromfdutf.BudgetHead}</td> */}
                                <td style={{ padding: "10px" }}>
                                  {releasefromfdutf.ReleaseDate?.split(
                                    "T",
                                  )[0].replace(" ")}
                                </td>
                                {isMaker && (
                                  <td style={{ padding: "10px" }}>
                                    {releasefromfdutf.remark ||
                                      releasefromfdutf.Remark}
                                  </td>
                                )}
                                 {isMaker && (
                                  <td
                                    style={{
                                      padding: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        console.log(
                                          "========== EDIT CLICK ==========",
                                        );
                                        console.log(
                                          "Selected Row =",
                                          releasefromfdutf,
                                        );

                                        //setSelectedBills([releasefromfdutf.ReleaseID]);
                                        setEditData(releasefromfdutf);
                                        setOpenEdit(true);
                                      }}
                                      disabled={
                                        !selectedBills.includes(
                                          releasefromfdutf.UniqueID,
                                        ) || loading
                                      }
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        margin: "auto",
                                        padding: "6px 12px",
                                        backgroundColor:
                                          selectedBills.length <= 0
                                            ? "#f3eeee"
                                            : "#3627c1",

                                        color:
                                          selectedBills.length > 0
                                            ? "#ffffff"
                                            : "#3627c1",

                                        border: "1px solid #3627c1",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        cursor:
                                          selectedBills.includes(
                                            releasefromfdutf.UniqueID,
                                          ) && !loading
                                            ? "pointer"
                                            : "not-allowed",
                                      }}
                                    >
                                      <img
                                        src={Edit32WHITE}
                                        alt="Edit"
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                        }}
                                      />
                                      Edit
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="col-12 mt-3">
                  <div className="row">
                    <div
                      className="col-6 text-start"
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <button
                        onClick={() => approveorrejectSelected("Approved")}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        className="ms-0"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",

                          color:
                            selectedBills.length > 0 ? "#ffffff" : "#01B574",
                          border: "1px solid #39B54A",

                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src={Approved32}
                          alt="Approve"
                          style={{
                            width: "18px",
                            height: "18px",
                            flexShrink: 0,
                          }}
                        />
                        {loading ? "Processing..." : "Approve Selected"}
                      </button>

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(2)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",

                            color: selectedBills.length > 0 ? "#ffffff" : "red",
                            border: "1px solid #ff6b81",
                            borderRadius: "8px",

                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src={DeleteRed32}
                            alt="Reject"
                            style={{
                              width: "18px",
                              height: "18px",
                              filter:
                                selectedBills.length > 0
                                  ? "brightness(0) invert(1)"
                                  : "none",
                              flexShrink: 0,
                            }}
                          />
                          {loading ? "Processing..." : "Reject Selected"}
                        </button>
                      )}

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(3)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "#3627c1",

                            color:
                              selectedBills.length > 0 ? "#ffffff" : "#3627c1",
                            border: "1px solid #3627c1",
                            borderRadius: "8px",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                        <img
                      src={SendBack32}
                      alt="Send Back"
                      style={{
                        width: "18px",
                        height: "18px",
                        flexShrink: 0,
                        filter: selectedBills.length > 0
                          ? "brightness(0) invert(1)"
                          : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                      }}
                    />
                          {loading ? "Processing..." : "Send Back Selected"}
                        </button>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "15px",
                        padding: "10px 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* Showing */}
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#333",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Showing{" "}
                        {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
                        to{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length || 0)}{" "}
                        of {filteredBills?.length || 0} entries
                      </div>

                      {/* Pagination */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "18px",
                        }}
                      >
                        {/* Previous */}
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          style={{
                            border: "none",
                            background: "transparent",
                            color: currentPage === 1 ? "#999" : "#2ea4e7",
                            cursor:
                              currentPage === 1 ? "not-allowed" : "pointer",
                            fontSize: "13px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            opacity: currentPage === 1 ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "20px" }}>‹</span>
                          Previous
                        </button>

                        {/* Page Numbers */}
                        {getPageNumbers(currentPage, totalPages).map(
                          (pageNumber, index) => {
                            // Dots ko button mat banana
                            if (pageNumber === "...") {
                              return (
                                <span
                                  key={`ellipsis-${index}`}
                                  style={{
                                    fontSize: "13px",
                                    color: "#444",
                                  }}
                                >
                                  ...
                                </span>
                              );
                            }

                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  padding: 0,
                                  color:
                                    currentPage === pageNumber
                                      ? "#2ea4e7"
                                      : "#444",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                  fontWeight:
                                    currentPage === pageNumber ? "600" : "400",
                                  textDecoration:
                                    currentPage === pageNumber
                                      ? "underline"
                                      : "none",
                                }}
                              >
                                {pageNumber}
                              </button>
                            );
                          },
                        )}
                        {/* Next */}
                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages),
                            )
                          }
                          disabled={
                            currentPage === totalPages || totalPages === 0
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            color:
                              currentPage === totalPages || totalPages === 0
                                ? "#999"
                                : "#2ea4e7",
                            cursor:
                              currentPage === totalPages || totalPages === 0
                                ? "not-allowed"
                                : "pointer",
                            fontSize: "13px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            opacity:
                              currentPage === totalPages || totalPages === 0
                                ? 0.5
                                : 1,
                          }}
                        >
                          Next
                          <span style={{ fontSize: "20px" }}>›</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {rejectPanelhide === 2 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectPanelhide === 3 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "8rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("SendBack")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Send
                          Back
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            width: "100%",
            padding: "20px",
            background: "#f5f7fb",
            minHeight: "100vh",
          }}
        >
          {/* Back Button */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
            }}
          >
            <button
              onClick={() => {
                setOpenEdit(false);
                setEditData(null);
              }}
              style={{
                background: "#0d6efd",
                color: "#fff",
                border: "none",
                padding: "10px 18px",
                borderRadius: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              ← Back
            </button>
          </div>

          <LimitAllocation
            isEdit={true}
            projectDatainward={editData}
            onSuccess={() => {
              // close form
              setOpenEdit(false);

              // clear selected edit data
              setEditData(null);

              // refresh inward table
              ReleaseFromFinanceList();

              // clear selected rows
              setSelectedBills([]);
            }}
            onCancel={() => {
              setOpenEdit(false);

              setEditData(null);
            }}
          />
        </div>
      )}
    </>
  );
};

export default LimitAllocationInwardList;
